<div class="flex justify-between">
  <div class="flex flex-col w-1/2 p-4">
    <div class="flex flex-col">
      <div class="flex mb-2">
        <mat-icon *ngIf="busy"><mat-spinner diameter="15"></mat-spinner></mat-icon>
        <mat-form-field appearance="outline" class="mr-2" subscriptSizing="dynamic">
          <mat-label class="font-medium">Filter</mat-label>
          <input matInput [(ngModel)]="filter" />
        </mat-form-field>
        <mat-slide-toggle
          class="mt-5 mr-2"
          labelPosition="after"
          [checked]="activeInactiveBoolean"
          color="primary"
          (change)="activeInactiveToggle()"
        >
          <b>Current</b>
        </mat-slide-toggle>
      </div>
      <div class="mb-2">
        <mat-button-toggle-group [(ngModel)]="filterType">
          <mat-button-toggle value="">All</mat-button-toggle>
          <mat-button-toggle value="won">Won</mat-button-toggle>
          <mat-button-toggle *ngIf="activeInactiveBoolean" value="await">Awaiting Bids</mat-button-toggle>
          <mat-button-toggle *ngIf="activeInactiveBoolean" value="bid">Open Bids</mat-button-toggle>
          <mat-button-toggle *ngIf="!activeInactiveBoolean" value="lost">Lost</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <mat-card class="w-full mb-2 p-4 cursor-pointer" *ngFor="let install of filteredProjectInstallBidDetails" (click)="selectInstall(install)">
      <div class="flex w-full">
        <div class="flex flex-1 flex-col">
          <span *ngIf="!install.bidSequence || install.bidSequence == 0" class="font-bold">{{ (install.project.installDate) ? (install.project.installDate | date : 'shortDate') : 'Invalid Date' }}</span>
          <span *ngIf="install.bidSequence && install.bidSequence > 0" class="font-bold">{{ (install.installDate) ? (install.installDate | date : 'shortDate') : 'Invalid Date' }}</span>
          <span class="text-xs">{{ install.title }}</span>
          <span class="text-xs">{{ install.project.city }}, {{ install.project.state}}</span>
        </div>
        <div class="mr-4 flex flex-col justify-center text-xs w-32">
          <ng-container *ngIf="bidAccepted(install)">
            <span *ngIf="install.request.bidCrewId">{{ getInstallCrew(install) }}</span>
            <span *ngIf="!install.request.bidCrewId">Crew not specified.</span>
          </ng-container>
        </div>
        <div class="flex flex-col items-end justify-center w-24" *ngIf="!install.bidSequence || install.bidSequence == 0">
          <span *ngIf="install.request.bidAmount" class="font-bold">{{ (install.request.bidStatus === 'ACCEPTED') ? (install.request.bidAmountAwarded | currency:'USD':'symbol':'1.0-0') : (install.request.bidAmount | currency) }}</span>
          <span *ngIf="install.request.bidAmount && install.request.bidStatus === 'ACCEPTED' && install.request.bidAmount !== install.request.bidAmountAwarded" class="font-normal text-xs">Orig: {{ install.request.bidAmount | currency:'USD':'symbol':'1.0-0' }}</span>
          <span *ngIf="install.request.bidAmount" class="text-xs">{{ install.request.bidStatus }}</span>
          <span *ngIf="!install.request.bidAmount" class="font-bold">{{openStatusDescription(install)}}</span>
          <span *ngIf="!install.request.bidAmount" class="text-xs">Due: {{dueDate(install.bidDate, install.project.installDate) | date: 'shortDate'}}</span>
        </div>
        <div class="flex flex-col items-end justify-center w-24" *ngIf="install.bidSequence && install.bidSequence > 0">
          <span class="font-bold">Cancelled</span>
        </div>
      </div>
    </mat-card>
  </div>
  <div class="flex w-1/2 m-2 ml-0">
    <mat-card *ngIf="selectedInstall" class="flex w-full h-fit p-2">
        <app-install-bid class="w-full" [projectInstallBidDetails]="selectedInstall" [installerCrew]="installerCrew" [multiView]="true"
        (crewChangeEmitter)="handleCrewChange($event)">
        </app-install-bid>
    </mat-card>
  </div>
</div>
